// @import_dependencies_node Import libraries
import React, {useEffect, useState} from 'react'
// @end

// @import services
import Emitter from 'app_services/emitter'
// @end

// @import types
import { IColorsTheme } from 'app_types/colors'
// @end

export const useColors = () => {
  const [colors, updateColors] = useState({} as IColorsTheme)

  useEffect(() => {
    // Sucribirme a los cambios del theme
    Emitter.on('change-theme', handleUpdate)
    // Solicitar colores
    const getEvent =  Math.round(Math.random()*1000).toString()
    Emitter.once(getEvent, handleUpdate)
    Emitter.emit('get-colors',getEvent)
    // Desuscribirme de los eventos
    return ()=>{
      Emitter.off('change-theme',handleUpdate)
    }
  }, [])

  const handleUpdate = (colorsTheme: any) => {
    updateColors(colorsTheme)
  }

  return [colors]
}
